import React from 'react';
import { Placeholder } from 'semantic-ui-react';
import * as MessageChartUI from './MessageChartUI';
import TimezonePopup from '../../../TimezonePopup';
import { scrollToElementById } from '../../../../utils/hooks';
import { globalFormat } from '../../../../utils/formatting';

/**
 * This Component is for the workspace message that contains Chart screenshot.
 * It allows user clicks the chart to scroll to the target chart in current workspace.
 */
export default function MessageChart(props: any) {
  const { dateFormat } = globalFormat.getGlobalFormat();
  // generate platform and analysis name
  const generateWorkspaceName = (analysis: any) => {
    if (analysis) {
      return `${analysis.display}`;
    } else {
      return 'Missing Analysis Data';
    }
  };
  // click the analysis name to scroll in workspace
  const scrollToAnnotationChart = (analysisId: string) => {
    scrollToElementById(`analysis-${analysisId}`, { inline: 'nearest' });
  };

  // return date range in text
  const generateDateRange = (analysis: any) => {
    if (analysis) {
      return (
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <TimezonePopup timestamp={analysis.start} dateFormat={dateFormat} />
          <span style={{ margin: '0px 4px' }}>~</span>
          <TimezonePopup timestamp={analysis.end} dateFormat={dateFormat} />
        </div>
      );
    } else {
      return;
    }
  };

  return (
    <MessageChartUI.ChartMessageContainer hasMessageText={props.hasMessageText}>
      {props.imageData ? (
        <MessageChartUI.ChartImage
          onClick={() => props.toggleImage(!props.isImageClicked)}
          src={props.imageData}
        />
      ) : (
        <Placeholder style={{ height: 117, width: 244 }}>
          <Placeholder.Image />
        </Placeholder>
      )}
      {props.message.analysis && props.imageData && (
        <>
          <MessageChartUI.DateRange>
            {generateDateRange(props.message.analysis)}
          </MessageChartUI.DateRange>

          <MessageChartUI.ChartDescription>
            <MessageChartUI.ChartName
              hasMessageText={props.hasMessageText}
              onClick={() => scrollToAnnotationChart(props.message.analysis.id)}
            >
              {generateWorkspaceName(props.message.analysis)}
            </MessageChartUI.ChartName>
          </MessageChartUI.ChartDescription>
        </>
      )}
    </MessageChartUI.ChartMessageContainer>
  );
}
